module.exports = __webpack_public_path__ + "img/shanghaigongcheng.0152d2d5.jpg";